"use client";

import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Volver arriba"
      className="bg-green-main fixed bottom-24 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-colors hover:bg-[#047a2e]"
    >
      <ArrowUp className="h-6 w-6" />
    </button>
  );
};
